import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import PropTypes from 'prop-types';

import Card from '../../Card/Card';

const LinerChart = ({
 title, data, options, actions, styleContainer, loading
}) => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );
  ChartJS.defaults.font.family = '"Poppins", sans-serif';

  return (
    <Card
      headerTitle={title}
      showHeader={!!title}
      headerBordered={false}
      styleContainer={styleContainer}
    >
      {actions}
      {data?.labels?.length ? <Line data={data} options={options} /> : (
        <div className="min-h-[220px] flex items-center justify-center text-text-muted">
          {loading ? 'Loading orders…' : 'No order data for this period'}
        </div>
      )}
    </Card>
  );
};

LinerChart.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  title: PropTypes.string,
  styleContainer: PropTypes.string,
  options: PropTypes.shape({}),
  actions: PropTypes.node,
  loading: PropTypes.bool,
};

LinerChart.defaultProps = {
  title: '',
  styleContainer: '',
  options: {
    responsive: true,
    plugins: {
      legend: false,
      title: {
        display: false,
      },
    },
  },
  actions: null,
  loading: false
};

export default LinerChart;
